<script>
  export let message = "";
  export let show = false;
  export let type = "success"; // Default to success type

  // Function to close the notification
  export function closeNotification() {
    show = false;
  }
</script>

{#if show}
  <div
    class="notification"
    class:notification-success={type === "success"}
    class:notification-danger={type === "danger"}
  >
    <span>{message}</span>
    <button class="close-button" on:click={closeNotification}>×</button>
  </div>
{/if}

<style>
  .notification {
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 15px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    z-index: 1000;
  }

  .notification-success {
    background-color: #4caf50;
    color: white;
  }

  .notification-danger {
    background-color: #ff0000;
    color: white;
  }

  .close-button {
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }

  .close-button:hover {
    color: #ddd;
  }
</style>
